<template>
    <b-modal id="timeEntryDetailModal" :hide-footer="true" size="lg">
        <template slot="modal-header">
            <h5 class="modal-title">{{ $t('str.timeline.timeEntry.title') }}</h5>
            <button type="button" class="btn-close" @click="$bvModal.hide('timeEntryDetailModal')"></button>
        </template>

        <dl class="row mb-0" v-if="selectedItem">
            <dt class="col-sm-4">{{ $t('str.register.guard.groups.account.field') }}</dt>
            <dd class="col-sm-8">{{ entityName(selectedItem.account) }}</dd>
            <dt class="col-sm-4">{{ $t('str.register.guard.groups.client.field') }}</dt>
            <dd class="col-sm-8">{{ entityName(selectedItem.client) }}</dd>
            <dt class="col-sm-4">{{ $t('str.register.guard.groups.site.field') }}</dt>
            <dd class="col-sm-8">{{ entityName(selectedItem.site) }}</dd>
            <dt class="col-sm-4">{{ $t('str.register.guard.groups.user.field') }}</dt>
            <dd class="col-sm-8">{{ userName(selectedItem.user) }}</dd>
            <dt class="col-sm-4">{{ $t('str.timeline.timeEntry.column.eventType') }}</dt>
            <dd class="col-sm-8">{{ $t(selectedItem.eventType) }}</dd>
            <dt class="col-sm-4">{{ $t('str.timeline.timeEntry.column.timestamp') }}</dt>
            <dd class="col-sm-8">{{ formatDate(selectedItem.timestamp || selectedItem.createdAt) }}</dd>
        </dl>
    </b-modal>
</template>

<script>
import Common from '../../../common/Common.vue'

export default {
    props: {
        selectedItem: {
            type: Object,
            default: () => null,
        },
    },
    methods: {
        entityName(entity) {
            return entity?.name || entity || '-'
        },
        userName(user) {
            return user?.fullName || [user?.firstName, user?.lastName].filter(Boolean).join(' ') || user || '-'
        },
        formatDate(value) {
            return value ? Common.formatDateAndTime(value) : '-'
        },
    },
}
</script>
